import { Controller } from '@hotwired/stimulus'
import Sortable from 'sortablejs'

export default class extends Controller {
  static targets = ['list']
  static values = {
    realEstateAdminId: String,
    rotationId: String,
    rotationResource: { type: String, default: 'lead_assignment_rotations' },
  }

  connect() {
    this.initializeSortable()
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  initializeSortable() {
    if (this.hasListTarget) {
      this.sortable = Sortable.create(this.listTarget, {
        animation: 150,
        handle: '.cursor-move',
        filter: 'input[type=number]',
        preventOnFilter: false,
        ghostClass: 'sortable-ghost',
        chosenClass: 'sortable-chosen',
        dragClass: 'sortable-drag',
        onEnd: this.onSortEnd.bind(this),
      })
    }
  }

  onSortEnd(event) {
    if (event.oldIndex === event.newIndex) {
      return // No change in position
    }

    // Get the new order of user IDs
    const userIds = Array.from(this.listTarget.children).map((item) => {
      return item.dataset.userId
    })

    // Send the new order to the server
    this.updateUserOrder(userIds)
  }

  updateUserOrder(userIds) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')

    fetch(
      `/real_estate_admin/${this.realEstateAdminIdValue}/${this.rotationResourceValue}/${this.rotationIdValue}/reorder_users`,
      {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
          Accept: 'application/json',
        },
        body: JSON.stringify({
          user_ids: userIds,
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 'success') {
          this.showSuccessMessage(data.message)
          this.updatePositionNumbers()
        } else {
          throw new Error(data.message)
        }
      })
      .catch((error) => {
        console.error('Error updating user order:', error)
        this.showErrorMessage('Erro ao reordenar usuários. A página será recarregada.')
        setTimeout(() => window.location.reload(), 2000)
      })
  }

  updatePositionNumbers() {
    // Update the position numbers in the UI
    const positionElements = this.listTarget.querySelectorAll('.bg-yellow-100')
    positionElements.forEach((element, index) => {
      element.textContent = (index + 1).toString()
    })
  }

  showSuccessMessage(message) {
    this.showFlashMessage(message, 'success')
  }

  showErrorMessage(message) {
    this.showFlashMessage(message, 'error')
  }

  showFlashMessage(message, type) {
    window.showNotification(message, type)
  }
}
